import React from "react"
import "./experiment-container.scss"
import { PropTypes } from "prop-types"

const ExperimentContainer = ({ children }) => (
  <div className="experimentContainer">{children}</div>
)

ExperimentContainer.propTypes = {
  children: PropTypes.element.isRequired
}
export default ExperimentContainer
